import React from "react";
import Header from "./Header";
import EditorPage from "./Editor";
import axios from "axios";
import { toast } from "react-toastify";
import { BiTime } from "react-icons/bi";
import { MdMemory } from "react-icons/md";

const MAX_RETRIES = 5;

class Home extends React.Component {
  // state
  constructor(props) {
    super(props);

    this.state = {
      source: "",
      language_id: 53,
      change: false,
      output: "",
      input: "",
      running: false,
      time: 0,
      memory: 0,
    };

    // bind
    this.callme = this.callme.bind(this);
  }

  // lifecycle
  componentDidMount = () => {
    const language = localStorage.getItem("language");
    if (language) {
      this.setState({ language_id: Number(language) });
    } else {
      localStorage.setItem("language", this.state.language_id);
    }
    console.log(window.location);
    if (window.location.search === "?ref=producthunt") {
      var arr = [];
      arr.push("I am Here by product Hunt");
      axios
        .post(
          "https://v1.nocodeapi.com/dhwajgupta/google_sheets/CePTSyoMDTWuhWRP?tabId=IDE",
          [arr]
        )
        .then((res) => {
          console.log("done");
        });
    }
  };

  // change language state
  changeLanguage = (id, change) => {
    console.log(id, change);
    this.setState({ language_id: id, change: change });
    localStorage.setItem("language", Number(id));
  };

  // convert to base64
  setOutput = (code) => {
    this.setState({ output: atob(code) });
  };

  // call api
  callme = (submissionId) => {
    var networkPromise = axios.get(`/api/judge/submissions/${submissionId}`);

    var timeOutPromise = new Promise(function (resolve, reject) {
      // 2 Second delay
      setTimeout(resolve, 2000, "Timeout Done");
    });

    return Promise.all([networkPromise, timeOutPromise, this]);
  };

  // run program
  setStatus = (msg) => {
    if (msg === "Accepted") {
      msg = "Compiled Successfully";
    }
    toast.info(msg, {
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
  };

  // run program
  callretry = (retry, submissionId) => {
    const reponse = this.callme(submissionId);
    reponse.then((res) => {
      retry--;
      console.log(res);
      const submissionData = res[0]?.data;
      if (
        submissionData.compile_output ||
        submissionData.stdout ||
        submissionData.stderr
      ) {
        this.setOutput(
          submissionData.compile_output ||
            submissionData.stderr ||
            submissionData.stdout
        );
        this.setStatus(submissionData?.status?.description);
        this.setState({
          running: false,
          time: submissionData?.time,
          memory: submissionData?.memory / 1000,
        });
        return;
      } else if (submissionData.status.description === "Time Limit Exceeded") {
        // this.setOutput("Time Limit Exceeded");
        this.setStatus(submissionData?.status?.description);
        this.setState({
          running: false,
          time: submissionData?.time,
          memory: submissionData?.memory / 1000,
        });
        return;
      } else if (submissionData.status.description === "Accepted") {
        this.setStatus(submissionData?.status?.description);
        this.setState({
          running: false,
          time: submissionData?.time,
          memory: submissionData?.memory / 1000,
        });
        return;
      } else if (retry > 0) {
        this.callretry(retry, submissionId);
      }
    });
  };

  // run program
  runProgram = (code) => {
    this.setState({ running: true, change: false, time: 0, memory: 0 });
    var encryptCode = btoa(code);
    var encryptInput = btoa(this.state.input);
    var obj = {
      source_code: encryptCode,
      language_id: this.state.language_id,
      stdin: encryptInput,
    };
    axios
      .post("/api/judge/run", obj)
      .then((res) => {
        const submissionId = res.data.token;
        var retry = MAX_RETRIES;
        this.callretry(retry, submissionId);
      })
      .catch((err) => {
        this.setState({ running: false });
      });
  };

  // render
  render() {
    return (
      <>
        {/* Header Component */}
        <Header
          language_id={this.state.language_id}
          changeLanguage={this.changeLanguage}
        />
        <div className="row">
          {/* Editor */}
          <div
            className="col-md-8 p-0"
            style={{ height: "calc(100vh - 60px)" }}
          >
            <EditorPage
              language_id={this.state.language_id}
              change={this.state.change}
              changeLanguage={this.changeLanguage}
              runProgram={this.runProgram}
              running={this.state.running}
            />
          </div>
          {/* Input Output Time Memory */}
          <div className="col-md-4 p-0">
            <div className="d-flex flex-column io-parent">
              <div className="io">
                <div className="input-banner">
                  <span>Input</span>
                </div>
                <textarea
                  rows="2"
                  wrap="off"
                  placeholder="Enter Input"
                  value={this.state.input}
                  spellCheck={false}
                  onChange={(e) => this.setState({ input: e.target.value })}
                ></textarea>
              </div>
              <div className="io">
                <div className="input-banner">
                  <span>Output</span>
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div>
                      <BiTime /> {this.state.time} (sec)
                    </div>
                    <div>
                      <MdMemory /> {this.state.memory} (MB)
                    </div>
                  </div>
                </div>
                <pre style={{ color: "white", height: "calc(100% - 50px)" }}>
                  {this.state.output}
                </pre>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Home;
